<template>
  <v-dialog v-model="openModal" width="1100px" max-height="700" min-height="400" scrollable>
    <logs-summary
      v-if="mode === 'summary'"
      :tags="tags"
      :log-title="logTitle"
      :card-title="cardTitle"
      :id-item="idItem"
      @close-modal="closeModal"
      @select-log="selectLog"
    />
    <log-details v-else-if="mode === 'details'" :log="selectedLog" :card-title="cardTitle" @close-modal="closeModal" @back-button-click="showSummary" />
  </v-dialog>
</template>

<script>
export default {
  name: 'LogsModal',
  components: {
    LogsSummary: () => import('./LogsSummary.vue'),
    LogDetails: () => import('./LogDetails.vue'),
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    tags: {
      type: String,
      required: true,
    },
    logTitle: {
      type: String,
      required: true,
    },
    idItem: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    mode: '',
    selectedLog: {},
  }),
  computed: {
    openModal: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
    cardTitle() {
      let textFormat

      if (this.logTitle === 'sms') {
        textFormat = this.logTitle.toUpperCase()
      } else {
        textFormat = this.logTitle
      }

      return `Log de alterações ${textFormat}`
    },
  },
  watch: {
    value() {
      if (this.value) this.mode = 'summary'
      else this.mode = ''
    },
  },
  methods: {
    closeModal() {
      this.openModal = false
    },
    selectLog(log) {
      this.mode = 'details'
      this.selectedLog = log
    },
    showSummary() {
      this.selectedLog = {}
      this.mode = 'summary'
    },
  },
}
</script>
